// import React, { useEffect, useState, useRef } from 'react';
// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { Badge, Form } from 'react-bootstrap';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
// import {
//   AddItemConversion,
//   GetItemConversionByItemId,
//   DeleteItemConversion
// } from '@store/INV/MasterItems/ItemConversionSlice';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetItemConversionByItemId from '@hooks/INV/ItemConversion/useGetItemConversionByItemId';
// import { ItemConversionSchema } from '../../../../ValidationForm/validationSchema';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';
// import Barcode from 'react-barcode';
// import { getNewItemBarcode } from '@store/INV/MasterItems/MasterItemsSlice';
// import { useReactToPrint } from 'react-to-print';
// import Pagination from '@components/Shared/Pagination/Pagination';
// import { Card, CardBody } from '@components/card/card';

// interface ItemConversionProps {
//   Item: any;
// }

// const BarcodeDisplay: React.FC<{ value?: string }> = ({ value }) =>
//   value ? (
//     <div style={{ maxWidth: '120px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <Barcode value={value} width={1} height={20} fontSize={14} margin={2} />
//     </div>
//   ) : null;

// const ItemConversion: React.FC<ItemConversionProps> = ({ Item }) => {
//   const { t, i18n } = useTranslation();
//   const { HasPermission } = usePermissions();
//   const dispatch = useAppDispatch();

//   // States
//   const [loadBarcode, setLoadBarcode] = useState(false);
//   const [searchTerm, setSearchTerm] = useState<string>('');
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [dataPerPage, setDataPerPage] = useState<number>(5);
//   const [printData, setPrintData] = useState<{
//     itemName: string;
//     uomName: string;
//     barcode: string;
//     price: number;
//     copies: number;
//   } | null>(null);

//   // Refs
//   const printRef = useRef<HTMLDivElement>(null);

//   // Hooks
//   const { UnitsOfMeasureList, loading: unitsLoading, error: unitsError } = useGetUnitsOfMeasureList();
//   const {
//     ItemConversionListByItem,
//     loading: conversionsLoading,
//     error: conversionsError
//   } = useGetItemConversionByItemId(Item.id ?? '');
//   const { MasterItemsById } = useAppSelector(a => a.MasterItemsINV);

//   // Print Hook
//   const handleReactToPrint = useReactToPrint({
//     contentRef: printRef,
//     documentTitle: `Barcode_${Item.name}_${new Date().toLocaleDateString()}`
//   });

//   // Filter conversions based on search
//   const filteredConversions = ItemConversionListByItem?.filter((item: any) => {
//     if (!searchTerm.trim()) return true;

//     const searchLower = searchTerm.toLowerCase();
//     const uomName = getUomName(item.uom)?.toLowerCase() || '';
//     const barcode = item.barcode?.toLowerCase() || '';

//     return uomName.includes(searchLower) || barcode.includes(searchLower);
//   });

//   // Pagination calculations
//   const indexOfLastItem = currentPage * dataPerPage;
//   const indexOfFirstItem = indexOfLastItem - dataPerPage;
//   const currentConversions = filteredConversions?.slice(indexOfFirstItem, indexOfLastItem) || [];

//   // Statistics
//   const totalConversions = ItemConversionListByItem?.length || 0;
//   const mainUnitCount = 1; // Always 1 for main unit
//   const subUnitCount = totalConversions;

//   // Helper Functions
//   const getUomName = (id: string) => {
//     const uom = UnitsOfMeasureList.find(f => f.id === id);
//     return i18n.language === 'en' ? uom?.name : uom?.name2 || uom?.name;
//   };

//   // Formik
//   const formik = useFormik({
//     initialValues: {
//       itemId: Item.id,
//       uom: '',
//       conversionValue: 0,
//       barcode: ''
//     },
//     validationSchema: ItemConversionSchema(t),
//     onSubmit: async values => {
//       try {
//         const res = await dispatch(
//           AddItemConversion({
//             itemId: values.itemId,
//             uom: values.uom,
//             conversionValue: Number(values.conversionValue),
//             barcode: values.barcode
//           })
//         ).unwrap();

//         if (res.succeeded) {
//           formik.resetForm();
//           CustomAlert({ action: 'Add' });
//           dispatch(GetItemConversionByItemId(Item.id || ''));
//           setCurrentPage(1); // Reset to first page
//         } else {
//           CustomAlert({ action: 'Error' });
//         }
//       } catch (error: any) {
//         CustomAlert({ action: 'Error', msg: error.message });
//       } finally {
//         formik.setSubmitting(false);
//       }
//     }
//   });

//   // Event Handlers
//   const handleDelete = async (item: any) => {
//     const isConfirm = await confirmAction(t('ConfirmDelete'));
//     if (!isConfirm) return;

//     try {
//       await dispatch(DeleteItemConversion({ id: item.id })).unwrap();
//       dispatch(GetItemConversionByItemId(Item.id || ''));
//       CustomAlert({ action: 'Delete' });
//     } catch (error: any) {
//       CustomAlert({ action: 'Error', msg: error.message });
//     }
//   };

//   const generateBarcode = async () => {
//     try {
//       setLoadBarcode(true);
//       const res = await dispatch(getNewItemBarcode()).unwrap();
//       formik.setFieldValue('barcode', res.succeeded ? res.data : '0');
//     } catch {
//       formik.setFieldValue('barcode', '0');
//     } finally {
//       setLoadBarcode(false);
//     }
//   };

//   const handlePrintBarcode = (barcode: string, itemName: string, uomName?: string, price: number = 0) => {
//     const copiesStr = prompt(t('Enter number of copies to print') + ' (1-100):', '1');
//     if (!copiesStr) return;
//     const copies = parseInt(copiesStr);
//     if (isNaN(copies) || copies <= 0) return;

//     setPrintData({ itemName, uomName: uomName || '', barcode, price, copies });
//   };

//   // Effects
//   useEffect(() => {
//     if (printData) {
//       setTimeout(() => handleReactToPrint(), 100);
//     }
//   }, [printData]);

//   const clearSearch = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//   };

//   const handleDataPerPageChange = (newDataPerPage: number) => {
//     setDataPerPage(newDataPerPage);
//     setCurrentPage(1);
//   };

//   return (
//     <>
//       {/* Statistics Cards */}

//       <Card className='mb-4'>
//         <div className='card-header'>
//           <div className='d-flex flex-wrap justify-content-between align-items-center gap-2'>
//             {/* Title */}
//             <h6 className='mb-0 flex-shrink-0'>
//               <i className='fas fa-exchange-alt me-2'></i>
//               تحويلات الوحدات للصنف
//               {/* <span className='text-theme ms-2'>- {Item.name}</span> */}
//             </h6>
//           </div>
//         </div>

//         <div className='card-body'>
//           <Loading loading={unitsLoading || conversionsLoading} error={unitsError || conversionsError}>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0 text-nowrap'>
//                 <thead className='table-actived fw-bold'>
//                   <tr>
//                     <th className='small'>الوحدة</th>
//                     <th className='small'>قيمة التحويل</th>
//                     <th className='small'>الباركود</th>
//                     <th className='small'>النوع</th>
//                     <th className='small'>الإجراءات</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* Main Unit Row */}
//                   <tr className='table-success'>
//                     <td className='align-middle'>
//                       <div className='d-flex align-items-center'>
//                         <i className='fas fa-star fa-fw me-2 text-warning'></i>
//                         <strong>{getUomName(Item.unitOfMeasure)}</strong>
//                       </div>
//                     </td>
//                     <td className='align-middle'>
//                       <span className='badge bg-success bg-opacity-20 text-success fs-6'>1</span>
//                     </td>
//                     <td className='align-middle'>
//                       <BarcodeDisplay value={MasterItemsById.barcode} />
//                     </td>
//                     <td className='align-middle'>
//                       <Badge bg='success' className='px-2 py-1'>
//                         <i className='fas fa-crown me-1'></i>
//                         رئيسية
//                       </Badge>
//                     </td>
//                     <td className='align-middle'>
//                       <button
//                         type='button'
//                         className='btn btn-sm btn-outline-primary me-2'
//                         onClick={() =>
//                           handlePrintBarcode(
//                             MasterItemsById.barcode,
//                             MasterItemsById.name,
//                             getUomName(Item.unitOfMeasure),
//                             MasterItemsById.salesPrice || 0
//                           )
//                         }
//                         title='طباعة الباركود'
//                       >
//                         <i className='fas fa-print fa-fw'></i>
//                       </button>
//                     </td>
//                   </tr>

//                   {/* Sub Units */}
//                   {currentConversions.length > 0 ? (
//                     currentConversions.map((item: any) => (
//                       <tr className='table-secondary' key={item.id}>
//                         <td className='align-middle'>
//                           <div className='d-flex align-items-center'>
//                             <i className='fas fa-link fa-fw me-2 text-secondary'></i>
//                             <strong>{getUomName(item.uom)}</strong>
//                           </div>
//                         </td>
//                         <td className='align-middle'>
//                           <span className='badge bg-primary bg-opacity-20 text-primary fs-6'>
//                             {item.conversionValue}
//                           </span>
//                         </td>
//                         <td className='align-middle'>
//                           <BarcodeDisplay value={item.barcode} />
//                         </td>
//                         <td className='align-middle'>
//                           <Badge bg='secondary' className='px-2 py-1'>
//                             <i className='fas fa-link me-1'></i>
//                             فرعية
//                           </Badge>
//                         </td>
//                         <td className='align-middle'>
//                           <div className='d-flex gap-2'>
//                             <button
//                               type='button'
//                               className='btn btn-sm btn-outline-primary'
//                               onClick={() =>
//                                 handlePrintBarcode(item.barcode, Item.name, getUomName(item.uom), item.price || 0)
//                               }
//                               title='طباعة الباركود'
//                             >
//                               <i className='fas fa-print fa-fw'></i>
//                             </button>
//                             {HasPermission('INVUpdateUOMItem') && (
//                               <button
//                                 type='button'
//                                 className='btn btn-sm btn-outline-danger'
//                                 onClick={() => handleDelete(item)}
//                                 title='حذف التحويل'
//                               >
//                                 <i className='fas fa-trash-alt fa-fw'></i>
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={5} className='text-center py-4 text-muted'>
//                         <i className='fa fa-exchange-alt fa-2x mb-2'></i>
//                         <br />
//                         {searchTerm ? 'لا توجد نتائج للبحث' : 'لا توجد تحويلات مسجلة'}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div className='mt-3'>
//               <Pagination
//                 filteredData={filteredConversions || []}
//                 dataPerPage={dataPerPage}
//                 handlePagination={setCurrentPage}
//                 currentPage={currentPage}
//               />
//             </div>
//           </Loading>
//         </div>
//       </Card>

//       {/* Add New Conversion Form */}
//       <Card>
//         <div className='card-header'>
//           <h6 className='mb-0'>
//             <i className='fas fa-plus-circle me-2'></i>
//             إضافة وحدة تحويل جديدة
//           </h6>
//         </div>
//         <div className='card-body'>
//           <Form onSubmit={formik.handleSubmit}>
//             <div className='row align-items-end'>
//               {/* From Unit */}
//               <div className='col-xl-3 col-lg-6'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label fw-bold'>
//                     <i className='fas fa-from me-1'></i>
//                     {t('From')}
//                   </label>
//                   <div className='form-control text-theme bg-light d-flex align-items-center'>
//                     <i className='fas fa-weight me-2'></i>
//                     <span>{getUomName(Item.unitOfMeasure)}</span>
//                   </div>
//                   <div className='form-text small'>الوحدة الرئيسية للصنف</div>
//                 </div>
//               </div>

//               {/* To Unit */}
//               <div className='col-xl-3 col-lg-6'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label fw-bold'>
//                     <i className='fas fa-to me-1'></i>
//                     {t('UnitOfMeasure')}
//                   </label>
//                   <Form.Select
//                     name='uom'
//                     onChange={formik.handleChange}
//                     value={formik.values.uom || ''}
//                     isInvalid={!!(formik.touched.uom && formik.errors.uom)}
//                     className='border-theme'
//                   >
//                     <option value=''>اختر الوحدة...</option>
//                     {UnitsOfMeasureList?.map((unit, idx) => (
//                       <option key={idx} value={unit.id} disabled={unit.id === Item.unitOfMeasure}>
//                         {i18n.language === 'en' ? unit.name : unit.name2}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   <Form.Control.Feedback type='invalid'>{formik.errors.uom}</Form.Control.Feedback>
//                 </div>
//               </div>

//               {/* Conversion Value */}
//               <div className='col-xl-2 col-lg-4'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label fw-bold'>
//                     <i className='fas fa-balance-scale me-1'></i>
//                     {t('ConversionValue')}
//                   </label>
//                   <Form.Control
//                     className='fw-bold text-center border-theme'
//                     type='number'
//                     autoComplete='off'
//                     name='conversionValue'
//                     onChange={formik.handleChange}
//                     value={formik.values.conversionValue}
//                     isInvalid={!!(formik.touched.conversionValue && formik.errors.conversionValue)}
//                     min='0'
//                     step='0.01'
//                     placeholder='0.00'
//                   />
//                   <Form.Control.Feedback type='invalid'>{formik.errors.conversionValue}</Form.Control.Feedback>
//                 </div>
//               </div>

//               {/* Barcode */}
//               <div className='col-xl-4 col-lg-8'>
//                 <div className='form-group mb-3'>
//                   <label className='form-label fw-bold'>
//                     <i className='fas fa-barcode me-1'></i>
//                     {t('Barcode')}
//                   </label>
//                   <div className='input-group'>
//                     <span className='input-group-text bg-light'>
//                       <i className='fas fa-barcode'></i>
//                     </span>
//                     <Form.Control
//                       autoComplete='off'
//                       type='text'
//                       name='barcode'
//                       onChange={formik.handleChange}
//                       value={formik.values.barcode}
//                       isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
//                       placeholder='أدخل أو أنشئ باركود...'
//                       className='border-start-0'
//                     />
//                     <button
//                       type='button'
//                       className='btn btn-outline-theme'
//                       onClick={generateBarcode}
//                       title={t('GenerateBarcode')}
//                       disabled={loadBarcode}
//                     >
//                       {loadBarcode ? (
//                         <div className='spinner-border spinner-border-sm'></div>
//                       ) : (
//                         <>
//                           <i className='fas fa-magic'></i>
//                         </>
//                       )}
//                     </button>
//                   </div>
//                   <Form.Control.Feedback type='invalid'>{formik.errors.barcode}</Form.Control.Feedback>
//                 </div>
//               </div>

//               {/* Submit Button */}
//               <div className='col-xl-12'>
//                 <div className='d-flex justify-content-end border-top pt-3'>
//                   {HasPermission('INVUpdateUOMItem') && (
//                     <button
//                       disabled={formik.isSubmitting || !formik.isValid}
//                       type='submit'
//                       className='btn btn-theme px-4'
//                       style={{ minWidth: '150px' }}
//                     >
//                       {formik.isSubmitting ? (
//                         <>
//                           <div className='spinner-border spinner-border-sm me-2'></div>
//                           {t('Add')}
//                         </>
//                       ) : (
//                         <>
//                           <i className='fas fa-plus me-2'></i>
//                           {t('Add')}
//                         </>
//                       )}
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Form>
//         </div>
//       </Card>

//       {/* Hidden Print Content */}
//       <div style={{ display: 'none' }}>
//         <div ref={printRef} className='printable-content'>
//           {printData && (
//             <BarcodeLabel
//               itemName={printData.itemName}
//               uomName={printData.uomName}
//               barcode={printData.barcode}
//               copies={printData.copies}
//               price={printData.price}
//             />
//           )}
//         </div>
//       </div>

//       <style>
//         {`
//           @media print {
//             .printable-content,
//             .printable-content * {
//               visibility: visible;
//               direction: rtl;
//               font-family: "Tahoma", sans-serif;
//             }

//             body * {
//               visibility: hidden;
//             }

//             .printable-content {
//               position: absolute;
//               left: 0;
//               top: 0;
//               width: 100%;
//             }
//           }

//           .border-theme {
//             border-color: var(--bs-theme) !important;
//           }

//           .table-actived {
//             background-color: rgba(var(--bs-theme-rgb), 0.05);
//           }
//         `}
//       </style>
//     </>
//   );
// };

// // Barcode Label Component
// const BarcodeLabel = React.forwardRef(({ itemName, uomName, barcode, price, copies }: any, ref: any) => {
//   const { t } = useTranslation();
//   return (
//     <div
//       ref={ref}
//       style={{
//         display: 'flex',
//         flexWrap: 'wrap',
//         background: '#fff',
//         padding: '8px',
//         direction: 'rtl'
//       }}
//     >
//       {Array.from({ length: copies }).map((_, index) => (
//         <div
//           key={index}
//           style={{
//             width: '50mm',
//             height: '30mm',
//             border: '1px solid #ddd',
//             borderRadius: '4px',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             justifyContent: 'center',
//             textAlign: 'center',
//             margin: '2mm',
//             fontFamily: 'Arial, sans-serif',
//             padding: '4px',
//             backgroundColor: '#f8f9fa'
//           }}
//         >
//           <div style={{ fontSize: 10, fontWeight: 'bold', marginBottom: '4px' }}>{itemName}</div>
//           <div style={{ fontSize: 9, color: '#666', marginBottom: '4px' }}>
//             {uomName} | {price?.toLocaleString()} {t('currency')}
//           </div>
//           <div style={{ transform: 'scale(1.1)', marginTop: '2px' }}>
//             <Barcode value={barcode} width={1} height={25} fontSize={10} margin={0} />
//           </div>
//           <div style={{ fontSize: 8, color: '#999', marginTop: '4px' }}>{new Date().toLocaleDateString('ar-SA')}</div>
//         </div>
//       ))}
//     </div>
//   );
// });

// BarcodeLabel.displayName = 'BarcodeLabel';

// export default ItemConversion;

import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { Badge, Form } from 'react-bootstrap';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
import {
  AddItemConversion,
  GetItemConversionByItemId,
  DeleteItemConversion
} from '@store/INV/MasterItems/ItemConversionSlice';
import Loading from '@components/Shared/Loader/Loading';
import useGetItemConversionByItemId from '@hooks/INV/ItemConversion/useGetItemConversionByItemId';
import { ItemConversionSchema } from '../../../../ValidationForm/validationSchema';
import confirmAction from '@components/Shared/Alert/confirmAction';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Barcode from 'react-barcode';
import { getNewItemBarcode } from '@store/INV/MasterItems/MasterItemsSlice';
import { useReactToPrint } from 'react-to-print';
import Pagination from '@components/Shared/Pagination/Pagination';
import { Card, CardBody } from '@components/card/card';

import Select from 'react-select';

interface ItemConversionProps {
  Item: any;
}

const BarcodeDisplay: React.FC<{ value?: string }> = ({ value }) =>
  value ? (
    <div style={{ maxWidth: '120px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Barcode value={value} width={1} height={20} fontSize={14} margin={2} />
    </div>
  ) : null;

const ItemConversion: React.FC<ItemConversionProps> = ({ Item }) => {
  const { t, i18n } = useTranslation();
  const { HasPermission } = usePermissions();
  const dispatch = useAppDispatch();

  // States
  const [loadBarcode, setLoadBarcode] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [dataPerPage, setDataPerPage] = useState<number>(5);
  const [printData, setPrintData] = useState<{
    itemName: string;
    uomName: string;
    barcode: string;
    price: number;
    copies: number;
  } | null>(null);
  const [isMainUnitSelected, setIsMainUnitSelected] = useState<boolean>(false);

  // Refs
  const printRef = useRef<HTMLDivElement>(null);

  // Hooks
  const { UnitsOfMeasureList, loading: unitsLoading, error: unitsError } = useGetUnitsOfMeasureList();
  const {
    ItemConversionListByItem,
    loading: conversionsLoading,
    error: conversionsError
  } = useGetItemConversionByItemId(Item.id ?? '');
  const { MasterItemsById } = useAppSelector(a => a.MasterItemsINV);

  // Print Hook
  const handleReactToPrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Barcode_${Item.name}_${new Date().toLocaleDateString()}`
  });

  // Filter conversions based on search
  const filteredConversions = ItemConversionListByItem?.filter((item: any) => {
    if (!searchTerm.trim()) return true;

    const searchLower = searchTerm.toLowerCase();
    const uomName = getUomName(item.uom)?.toLowerCase() || '';
    const barcode = item.barcode?.toLowerCase() || '';

    return uomName.includes(searchLower) || barcode.includes(searchLower);
  });

  // Pagination calculations
  const indexOfLastItem = currentPage * dataPerPage;
  const indexOfFirstItem = indexOfLastItem - dataPerPage;
  const currentConversions = filteredConversions?.slice(indexOfFirstItem, indexOfLastItem) || [];

  // Statistics
  const totalConversions = ItemConversionListByItem?.length || 0;
  const mainUnitCount = 1; // Always 1 for main unit
  const subUnitCount = totalConversions;

  // Helper Functions
  const getUomName = (id: string) => {
    const uom = UnitsOfMeasureList.find(f => f.id === id);
    return i18n.language === 'en' ? uom?.name : uom?.name2 || uom?.name;
  };

  const isMainUnit = (uomId: string): boolean => {
    return uomId === Item.unitOfMeasure;
  };

  // Formik
  const formik = useFormik({
    initialValues: {
      itemId: Item.id,
      uom: '',
      conversionValue: 0,
      barcode: ''
    },
    validationSchema: ItemConversionSchema(t),
    onSubmit: async values => {
      try {
        // التأكد من أن قيمة التحويل 1 للوحدة الرئيسية
        const conversionValue = isMainUnit(values.uom) ? 1 : Number(values.conversionValue);

        const res = await dispatch(
          AddItemConversion({
            itemId: values.itemId,
            uom: values.uom,
            conversionValue: conversionValue,
            barcode: values.barcode
          })
        ).unwrap();

        if (res.succeeded) {
          formik.resetForm();
          setIsMainUnitSelected(false);
          CustomAlert({ action: 'Add' });
          dispatch(GetItemConversionByItemId(Item.id || ''));
          setCurrentPage(1); // Reset to first page
        } else {
          CustomAlert({ action: 'Error' });
        }
      } catch (error: any) {
        CustomAlert({ action: 'Error', msg: error.message });
      } finally {
        formik.setSubmitting(false);
      }
    }
  });

  // Event Handlers
  const handleDelete = async (item: any) => {
    const isConfirm = await confirmAction(t('ConfirmDelete'));
    if (!isConfirm) return;

    try {
      await dispatch(DeleteItemConversion({ id: item.id })).unwrap();
      dispatch(GetItemConversionByItemId(Item.id || ''));
      CustomAlert({ action: 'Delete' });
    } catch (error: any) {
      CustomAlert({ action: 'Error', msg: error.message });
    }
  };

  const generateBarcode = async () => {
    try {
      setLoadBarcode(true);
      const res = await dispatch(getNewItemBarcode()).unwrap();
      formik.setFieldValue('barcode', res.succeeded ? res.data : '0');
    } catch {
      formik.setFieldValue('barcode', '0');
    } finally {
      setLoadBarcode(false);
    }
  };

  const handlePrintBarcode = (barcode: string, itemName: string, uomName?: string, price: number = 0) => {
    const copiesStr = prompt(t('Enter number of copies to print') + ' (1-100):', '1');
    if (!copiesStr) return;
    const copies = parseInt(copiesStr);
    if (isNaN(copies) || copies <= 0) return;

    setPrintData({ itemName, uomName: uomName || '', barcode, price, copies });
  };

  // Handle UOM selection change
  const handleUomChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedUom = e.target.value;
    const isMain = isMainUnit(selectedUom);

    setIsMainUnitSelected(isMain);

    // إذا كانت الوحدة الرئيسية، ضع قيمة التحويل 1
    if (isMain) {
      formik.setFieldValue('conversionValue', 1);
    }

    formik.handleChange(e);
  };

  // Effects
  useEffect(() => {
    if (printData) {
      setTimeout(() => handleReactToPrint(), 100);
    }
  }, [printData]);

  const clearSearch = () => {
    setSearchTerm('');
    setCurrentPage(1);
  };

  const handleDataPerPageChange = (newDataPerPage: number) => {
    setDataPerPage(newDataPerPage);
    setCurrentPage(1);
  };

  // إعادة تعيين الحالة عند إعادة تعيين النموذج
  useEffect(() => {
    if (!formik.values.uom) {
      setIsMainUnitSelected(false);
    }
  }, [formik.values.uom]);

  const optionUom = UnitsOfMeasureList?.map(unit => ({
    ...unit,
    value: unit.id,
    label: i18n.language === 'en' ? unit.name : unit.name2 || unit.name
    // isDisabled: unit.id === Item.unitOfMeasure
  }));

  return (
    <>
      <Card className='mb-4'>
        <div className='card-header'>
          <div className='d-flex flex-wrap justify-content-between align-items-center gap-2'>
            {/* Title */}
            <h6 className='mb-0 flex-shrink-0'>
              <i className='fas fa-exchange-alt me-2'></i>
              تحويلات الوحدات للصنف
            </h6>

            {/* Search and Data Per Page */}
            <div className='d-flex flex-wrap align-items-center gap-2 ms-auto'>
              {/* Items per page */}
              <div className='flex-shrink-0'>
                <div className='d-flex align-items-center'>
                  <span className='me-2 small d-none d-sm-inline'>عدد:</span>
                  <select
                    className='form-select form-select-sm'
                    style={{ minWidth: '80px' }}
                    value={dataPerPage}
                    onChange={e => handleDataPerPageChange(Number(e.target.value))}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>

              {/* Search bar */}
              <div className='input-group input-group-sm' style={{ minWidth: '200px', maxWidth: '300px' }}>
                <span className='input-group-text'>
                  <i className='fas fa-search text-muted'></i>
                </span>
                <input
                  type='text'
                  className='form-control border-start-0'
                  placeholder='ابحث بالوحدة أو الباركود...'
                  value={searchTerm}
                  onChange={e => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                {searchTerm && (
                  <button className='btn btn-outline-secondary' type='button' onClick={clearSearch} title='مسح البحث'>
                    <i className='fas fa-times'></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='card-body'>
          <Loading loading={unitsLoading || conversionsLoading} error={unitsError || conversionsError}>
            <div className='table-responsive'>
              <table className='table table-hover mb-0 text-nowrap'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='small'>الوحدة</th>
                    <th className='small'>قيمة التحويل</th>
                    <th className='small'>الباركود</th>
                    <th className='small'>النوع</th>
                    <th className='small'>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Main Unit Row */}
                  <tr className='table-success'>
                    <td className='align-middle'>
                      <div className='d-flex align-items-center'>
                        <i className='fas fa-star fa-fw me-2 text-warning'></i>
                        <strong>{getUomName(Item.unitOfMeasure)}</strong>
                      </div>
                    </td>
                    <td className='align-middle'>
                      <span className='badge bg-success bg-opacity-20 text-success fs-6'>1</span>
                    </td>
                    <td className='align-middle'>
                      <BarcodeDisplay value={MasterItemsById.barcode} />
                    </td>
                    <td className='align-middle'>
                      <Badge bg='success' className='px-2 py-1'>
                        <i className='fas fa-crown me-1'></i>
                        رئيسية
                      </Badge>
                    </td>
                    <td className='align-middle'>
                      <button
                        type='button'
                        className='btn btn-sm btn-outline-primary me-2'
                        onClick={() =>
                          handlePrintBarcode(
                            MasterItemsById.barcode,
                            MasterItemsById.name,
                            getUomName(Item.unitOfMeasure),
                            MasterItemsById.salesPrice || 0
                          )
                        }
                        title='طباعة الباركود'
                      >
                        <i className='fas fa-print fa-fw'></i>
                      </button>
                    </td>
                  </tr>

                  {/* Sub Units */}
                  {currentConversions.length > 0 ? (
                    currentConversions.map((item: any) => (
                      <tr className='table-secondary' key={item.id}>
                        <td className='align-middle'>
                          <div className='d-flex align-items-center'>
                            <i className='fas fa-link fa-fw me-2 text-secondary'></i>
                            <strong>{getUomName(item.uom)}</strong>
                          </div>
                        </td>
                        <td className='align-middle'>
                          <span className='badge bg-primary bg-opacity-20 text-primary fs-6'>
                            {item.conversionValue}
                          </span>
                        </td>
                        <td className='align-middle'>
                          <BarcodeDisplay value={item.barcode} />
                        </td>
                        <td className='align-middle'>
                          <Badge bg='secondary' className='px-2 py-1'>
                            <i className='fas fa-link me-1'></i>
                            فرعية
                          </Badge>
                        </td>
                        <td className='align-middle'>
                          <div className='d-flex gap-2'>
                            <button
                              type='button'
                              className='btn btn-sm btn-outline-primary'
                              onClick={() =>
                                handlePrintBarcode(item.barcode, Item.name, getUomName(item.uom), item.price || 0)
                              }
                              title='طباعة الباركود'
                            >
                              <i className='fas fa-print fa-fw'></i>
                            </button>
                            {HasPermission('INVUpdateUOMItem') && (
                              <button
                                type='button'
                                className='btn btn-sm btn-outline-danger'
                                onClick={() => handleDelete(item)}
                                title='حذف التحويل'
                              >
                                <i className='fas fa-trash-alt fa-fw'></i>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className='text-center py-4 text-muted'>
                        <i className='fa fa-exchange-alt fa-2x mb-2'></i>
                        <br />
                        {searchTerm ? 'لا توجد نتائج للبحث' : 'لا توجد تحويلات مسجلة'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className='mt-3'>
              <Pagination
                filteredData={filteredConversions || []}
                dataPerPage={dataPerPage}
                handlePagination={setCurrentPage}
                currentPage={currentPage}
              />
            </div>
          </Loading>
        </div>
      </Card>

      {/* Add New Conversion Form */}
      <Card>
        <div className='card-header'>
          <h6 className='mb-0'>
            <i className='fas fa-plus-circle me-2'></i>
            إضافة وحدة تحويل جديدة
          </h6>
        </div>
        <div className='card-body'>
          <Form onSubmit={formik.handleSubmit}>
            <div className='row align-items-end'>
              {/* From Unit */}
              <div className='col-xl-3 col-lg-6'>
                <div className='form-group mb-3'>
                  <label className='form-label fw-bold'>
                    <i className='fas fa-from me-1'></i>
                    {t('From')}
                  </label>
                  <div className='form-control text-theme bg-light d-flex align-items-center'>
                    <i className='fas fa-weight me-2'></i>
                    <span>{getUomName(Item.unitOfMeasure)}</span>
                  </div>
                  <div className='form-text small'>الوحدة الرئيسية للصنف</div>
                </div>
              </div>

              {/* To Unit */}

              <div className='col-xl-3 col-lg-6'>
                <div className='form-group mb-3'>
                  <label className='form-label fw-bold'>
                    <i className='fas fa-to me-1'></i>
                    {t('UnitOfMeasure')}
                  </label>

                  <Select
                    classNamePrefix='react-select'
                    name='uom'
                    value={optionUom?.find(option => option.id === formik.values.uom) || null}
                    onChange={(selectedOption: any) => {
                      const selectedUom = selectedOption?.id || '';
                      const isMain = isMainUnit(selectedUom);

                      setIsMainUnitSelected(isMain);

                      // إذا كانت الوحدة الرئيسية، ضع قيمة التحويل 1
                      if (isMain) {
                        formik.setFieldValue('conversionValue', 1);
                      }

                      formik.setFieldValue('uom', selectedUom);
                    }}
                    options={optionUom}
                    isSearchable={true}
                    isClearable={true}
                    placeholder='ابحث أو اختر الوحدة...'
                    isLoading={unitsLoading}
                    noOptionsMessage={() => 'لا توجد وحدات متاحة'}
                    // isOptionDisabled={(option: any) => option.isDisabled}
                    // className={`border-theme ${formik.touched.uom && formik.errors.uom ? 'is-invalid' : ''}`}
                  />

                  {formik.touched.uom && formik.errors.uom && (
                    <div className='invalid-feedback d-block' style={{ fontSize: '0.875em', marginTop: '0.25rem' }}>
                      <i className='fas fa-exclamation-circle me-1'></i>
                      {formik.errors.uom}
                    </div>
                  )}

                  {isMainUnitSelected && (
                    <div className='form-text text-warning small mt-2'>
                      <i className='fas fa-exclamation-circle me-1'></i>
                      قيمة التحويل ستكون 1 للوحدة الرئيسية
                    </div>
                  )}
                </div>
              </div>

              {/* Conversion Value */}
              <div className='col-xl-2 col-lg-4'>
                <div className='form-group mb-3'>
                  <label className='form-label fw-bold'>
                    <i className='fas fa-balance-scale me-1'></i>
                    {t('ConversionValue')}
                  </label>
                  <Form.Control
                    className='fw-bold text-center border-theme'
                    type='number'
                    autoComplete='off'
                    name='conversionValue'
                    onChange={formik.handleChange}
                    value={formik.values.conversionValue}
                    isInvalid={!!(formik.touched.conversionValue && formik.errors.conversionValue)}
                    min='0'
                    step='0.01'
                    placeholder='0.00'
                    disabled={isMainUnitSelected}
                    readOnly={isMainUnitSelected}
                  />
                  <Form.Control.Feedback type='invalid'>{formik.errors.conversionValue}</Form.Control.Feedback>
                  {isMainUnitSelected && (
                    <div className='form-text text-info small mt-1'>
                      <i className='fas fa-info-circle me-1'></i>
                      قيمة ثابتة للوحدة الرئيسية
                    </div>
                  )}
                </div>
              </div>

              {/* Barcode */}
              <div className='col-xl-4 col-lg-8'>
                <div className='form-group mb-3'>
                  <label className='form-label fw-bold'>
                    <i className='fas fa-barcode me-1'></i>
                    {t('Barcode')}
                  </label>
                  <div className='input-group'>
                    <span className='input-group-text bg-light'>
                      <i className='fas fa-barcode'></i>
                    </span>
                    <Form.Control
                      autoComplete='off'
                      type='text'
                      name='barcode'
                      onChange={formik.handleChange}
                      value={formik.values.barcode}
                      isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
                      placeholder='أدخل أو أنشئ باركود...'
                      className='border-start-0'
                    />
                    <button
                      type='button'
                      className='btn btn-outline-theme'
                      onClick={generateBarcode}
                      title={t('GenerateBarcode')}
                      disabled={loadBarcode}
                    >
                      {loadBarcode ? (
                        <div className='spinner-border spinner-border-sm'></div>
                      ) : (
                        <>
                          <i className='fas fa-magic'></i>
                        </>
                      )}
                    </button>
                  </div>
                  <Form.Control.Feedback type='invalid'>{formik.errors.barcode}</Form.Control.Feedback>
                </div>
              </div>

              {/* Submit Button */}
              <div className='col-xl-12'>
                <div className='d-flex justify-content-end border-top pt-3'>
                  {HasPermission('INVUpdateUOMItem') && (
                    <button
                      disabled={formik.isSubmitting || !formik.isValid}
                      type='submit'
                      className='btn btn-theme px-4'
                      style={{ minWidth: '150px' }}
                    >
                      {formik.isSubmitting ? (
                        <>
                          <div className='spinner-border spinner-border-sm me-2'></div>
                          {t('Add')}
                        </>
                      ) : (
                        <>
                          <i className='fas fa-plus me-2'></i>
                          {t('Add')}
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Card>

      {/* Hidden Print Content */}
      <div style={{ display: 'none' }}>
        <div ref={printRef} className='printable-content'>
          {printData && (
            <BarcodeLabel
              itemName={printData.itemName}
              uomName={printData.uomName}
              barcode={printData.barcode}
              copies={printData.copies}
              price={printData.price}
            />
          )}
        </div>
      </div>

      <style>
        {`
          @media print {
            .printable-content,
            .printable-content * {
              visibility: visible;
              direction: rtl;
              font-family: "Tahoma", sans-serif;
            }
            
            body * {
              visibility: hidden;
            }
            
            .printable-content {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }
          
          .border-theme {
            border-color: var(--bs-theme) !important;
          }
          
          .table-actived {
            background-color: rgba(var(--bs-theme-rgb), 0.05);
          }
        `}
      </style>
    </>
  );
};

// Barcode Label Component
const BarcodeLabel = React.forwardRef(({ itemName, uomName, barcode, price, copies }: any, ref: any) => {
  const { t } = useTranslation();
  return (
    <div
      ref={ref}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        background: '#fff',
        padding: '8px',
        direction: 'rtl'
      }}
    >
      {Array.from({ length: copies }).map((_, index) => (
        <div
          key={index}
          style={{
            width: '50mm',
            height: '30mm',
            border: '1px solid #ddd',
            borderRadius: '4px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            margin: '2mm',
            fontFamily: 'Arial, sans-serif',
            padding: '4px',
            backgroundColor: '#f8f9fa'
          }}
        >
          <div style={{ fontSize: 10, fontWeight: 'bold', marginBottom: '4px' }}>{itemName}</div>
          <div style={{ fontSize: 9, color: '#666', marginBottom: '4px' }}>
            {uomName} | {price?.toLocaleString()} {t('currency')}
          </div>
          <div style={{ transform: 'scale(1.1)', marginTop: '2px' }}>
            <Barcode value={barcode} width={1} height={25} fontSize={10} margin={0} />
          </div>
          <div style={{ fontSize: 8, color: '#999', marginTop: '4px' }}>{new Date().toLocaleDateString('ar-SA')}</div>
        </div>
      ))}
    </div>
  );
});

BarcodeLabel.displayName = 'BarcodeLabel';

export default ItemConversion;
